import {
  ANALYTICS_OVERVIEW_REQUEST,
  ANALYTICS_OVERVIEW_SUCCESS,
  ANALYTICS_OVERVIEW_FAILURE,
  ANALYTICS_CHANNELS_REQUEST,
  ANALYTICS_CHANNELS_SUCCESS,
  ANALYTICS_CHANNELS_FAILURE,
  ANALYTICS_USERS_REQUEST,
  ANALYTICS_USERS_SUCCESS,
  ANALYTICS_USERS_FAILURE,
  ANALYTICS_CHANNEL_DETAIL_REQUEST,
  ANALYTICS_CHANNEL_DETAIL_SUCCESS,
  ANALYTICS_CHANNEL_DETAIL_FAILURE,
  ANALYTICS_USER_DETAIL_REQUEST,
  ANALYTICS_USER_DETAIL_SUCCESS,
  ANALYTICS_USER_DETAIL_FAILURE,
} from '../../types';
import {
  getCommunityOverviewApi,
  getChannelBreakdownApi,
  getUserActivityApi,
  getChannelDetailApi,
  getUserDetailApi,
} from '../../api/analytics';

export const fetchCommunityOverview = (communityId: string, startDate: string, endDate: string) => async (dispatch: any) => {
  dispatch({ type: ANALYTICS_OVERVIEW_REQUEST });
  try {
    const response = await getCommunityOverviewApi(communityId, startDate, endDate);
    dispatch({ type: ANALYTICS_OVERVIEW_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: ANALYTICS_OVERVIEW_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch community overview',
    });
  }
};

export const fetchChannelBreakdown = (communityId: string, startDate: string, endDate: string) => async (dispatch: any) => {
  dispatch({ type: ANALYTICS_CHANNELS_REQUEST });
  try {
    const response = await getChannelBreakdownApi(communityId, startDate, endDate);
    dispatch({ type: ANALYTICS_CHANNELS_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: ANALYTICS_CHANNELS_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch channel breakdown',
    });
  }
};

export const fetchUserActivity = (communityId: string, startDate: string, endDate: string, limit?: number) => async (dispatch: any) => {
  dispatch({ type: ANALYTICS_USERS_REQUEST });
  try {
    const response = await getUserActivityApi(communityId, startDate, endDate, limit);
    dispatch({ type: ANALYTICS_USERS_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: ANALYTICS_USERS_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch user activity',
    });
  }
};

export const fetchChannelDetail = (channelId: string, startDate: string, endDate: string, communityIdentifier?: string) => async (dispatch: any) => {
  dispatch({ type: ANALYTICS_CHANNEL_DETAIL_REQUEST });
  try {
    const response = await getChannelDetailApi(channelId, startDate, endDate, communityIdentifier);
    dispatch({ type: ANALYTICS_CHANNEL_DETAIL_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: ANALYTICS_CHANNEL_DETAIL_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch channel detail',
    });
  }
};

export const fetchUserDetail = (userId: string, communityIdentifier: string, startDate: string, endDate: string) => async (dispatch: any) => {
  dispatch({ type: ANALYTICS_USER_DETAIL_REQUEST });
  try {
    const response = await getUserDetailApi(userId, communityIdentifier, startDate, endDate);
    dispatch({ type: ANALYTICS_USER_DETAIL_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: ANALYTICS_USER_DETAIL_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch user detail',
    });
  }
};
